export const environment = {
  version: '1.0',
  production: false,
  env: 'test',
  appName: 'MagnumEiDelivery',
  apiURLNew: 'https://unilever.dev.einteligent.com/WebServices',
};
